import { render, staticRenderFns } from "./PluginGatedContent.vue?vue&type=template&id=446e678e"
import script from "./PluginGatedContent.vue?vue&type=script&lang=js"
export * from "./PluginGatedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446e678e')) {
      api.createRecord('446e678e', component.options)
    } else {
      api.reload('446e678e', component.options)
    }
    module.hot.accept("./PluginGatedContent.vue?vue&type=template&id=446e678e", function () {
      api.rerender('446e678e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginGatedContent.vue"
export default component.exports